import StarOutlineIcon from '@mui/icons-material/StarOutline';

export const HighlightedResourceIcon = StarOutlineIcon;
